import React, { useEffect, useRef } from "react";
import { mediaUrl } from "@/lib/api";

// Live canvas preview of a photo with the tiled diagonal watermark + badge —
// mirrors the server-side (dealer_kit / media_watermark) look so sellers see
// exactly what will be applied before saving. Display-only (no pixel read),
// so cross-origin images never block rendering.
export default function WatermarkPreview({ src, text = "Pactly Car", className = "" }) {
  const canvasRef = useRef(null);
  useEffect(() => {
    if (!src) return;
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const maxW = 900;
      const scale = img.width > maxW ? maxW / img.width : 1;
      const W = Math.max(1, Math.round(img.width * scale));
      const H = Math.max(1, Math.round(img.height * scale));
      canvas.width = W; canvas.height = H;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, W, H);
      const label = String(text || "Pactly Car").trim().toUpperCase();

      ctx.save();
      const fs = Math.max(13, Math.round(W / 32));
      ctx.font = `600 ${fs}px Inter, system-ui, sans-serif`;
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.translate(W / 2, H / 2); ctx.rotate(-Math.PI / 6);
      const diag = Math.sqrt(W * W + H * H);
      const stepX = ctx.measureText(label).width + fs * 3.5;
      const stepY = fs * 4.5;
      for (let y = -diag / 2; y < diag / 2; y += stepY) {
        for (let x = -diag / 2; x < diag / 2; x += stepX) {
          ctx.shadowColor = "rgba(0,0,0,0.28)"; ctx.shadowBlur = 3;
          ctx.fillStyle = "rgba(255,255,255,0.13)";
          ctx.fillText(label, x, y);
        }
      }
      ctx.restore();

      ctx.save();
      const bfs = Math.max(11, Math.round(W / 46));
      ctx.font = `700 ${bfs}px Inter, system-ui, sans-serif`;
      const badge = `© ${label} · PACTLY CAR`;
      const pad = Math.round(bfs * 0.7);
      const bw = ctx.measureText(badge).width + pad * 2;
      const bh = bfs + pad * 1.4;
      const margin = Math.round(W / 90);
      const bx = W - bw - margin, by = H - bh - margin;
      ctx.fillStyle = "rgba(11,11,24,0.55)";
      if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(bx, by, bw, bh, 8); ctx.fill(); }
      else ctx.fillRect(bx, by, bw, bh);
      ctx.fillStyle = "rgba(255,255,255,0.92)";
      ctx.textAlign = "left"; ctx.textBaseline = "middle";
      ctx.fillText(badge, bx + pad, by + bh / 2);
      ctx.restore();
    };
    img.onerror = () => {};
    img.src = mediaUrl(src);
  }, [src, text]);
  return <canvas ref={canvasRef} className={className} data-testid="watermark-preview-canvas" />;
}
